<template>
  <div class="spinner-ellipsis">
    <div :class="background"></div>
    <div :class="background"></div>
    <div :class="background"></div>
    <div :class="background"></div>
  </div>
</template>

<script>
export default {
  name: "Spinner",
  props: {
    background: {
      type: String,
      default: "bg-white",
      validator: function(value) {
        return ["bg-dark", "bg-primary", "bg-white"].indexOf(value) !== -1;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.spinner-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.spinner-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.spinner-ellipsis div:nth-child(1) {
  left: 8px;
  animation: spinner-ellipsis1 0.6s infinite;
}

.spinner-ellipsis div:nth-child(2) {
  left: 8px;
  animation: spinner-ellipsis2 0.6s infinite;
}

.spinner-ellipsis div:nth-child(3) {
  left: 32px;
  animation: spinner-ellipsis2 0.6s infinite;
}

.spinner-ellipsis div:nth-child(4) {
  left: 56px;
  animation: spinner-ellipsis3 0.6s infinite;
}
@keyframes spinner-ellipsis1 {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}
@keyframes spinner-ellipsis3 {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0);
  }
}
@keyframes spinner-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(24px, 0);
  }
}
</style>
